// 推薦新聞 元件
import { useRouter } from 'next/navigation';
import Image from 'next/image';
import { DEFAULT_IMG } from '@/common/constant';
import { formatToDisplay } from '@/common/dateUtils';

const NewsRelatedComponent = ({ news, t, isDragging }) => {
    const router = useRouter();
    // 分類
    const category = t(news?.category1?.toUpperCase());
    // 顯示時間
    const displayTime = formatToDisplay(news?.releasedTime);
    // 連結
    const link = `/${news?.category1}/${news?.slug}`;

    return (
        <div className="relative group rounded-[12px] overflow-hidden bg-black flex flex-col flex-shrink-0">
            <div className="pb-[12px] flex-shrink-0">
                {/* 圖片 */}
                <div className="img-box w-full overflow-hidden aspect-[29/17]">
                    <Image
                        className="hover-img"
                        width={290}
                        height={170}
                        src={news?.img || DEFAULT_IMG}
                        alt={news?.alt || 'news-image'}
                        sizes="250px"
                    />
                </div>

                {/* 標題 */}
                <h3 className="px-[20px] mt-[14px] text-h6 text-black2 hover-text line-clamp-2 group-hover:decoration-white min-h-[44px] group-hover:text-white">
                    {news?.title}
                </h3>
            </div>

            <div className="between-center text-btn2 text-bou relative px-[20px] pb-[22px] ulg:flex-col ulg:flex-grow ulg:items-start ulg:pb-[16px]">
                <div className="between-center w-full">
                    {/* 大分類 */}
                    <a
                        href={`/${news?.category1}`}
                        className="user-drag trans hover:opacity-[.6] relative z-[3]"
                    >
                        {category}
                    </a>

                    {/* 新聞時間 */}
                    <span>{displayTime}</span>
                </div>
            </div>

            <a
                href={link}
                className="absolute top-0 left-0 w-full h-full z-[1] user-drag"
                onClick={(e) => {
                    e.preventDefault();
                    if (!isDragging) router.push(link);
                }}
            />
        </div>
    );
};

export default NewsRelatedComponent;
